import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";
import ProductTypeService from "../ProductTypeService";
import BaseSelectorReadonlyToInputV2 from "../../component/Select/BaseSelectorReadonlyToInputV2";

export const mapItems = (data) => {
  return {...data, id: data.id, referenceOrFriendlyName: data.reference + ' - ' + data.friendlyName};
};

class ProductTypeSelector extends BaseSelectorReadonlyToInputV2 {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Tipo de produto',
      label: 'referenceOrFriendlyName',
      value: 'id',
      mapItems,
      url: ProductTypeService.ALL_URL + '/combobox?active=true'
    };
  }

  componentWillMount() {
    this.props.defaultValueFunction && this.props.defaultValueFunction(this);
  }
}

ProductTypeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ProductTypeSelector;



// WEBPACK FOOTER //
// ./src/productType/component/ProductTypeSelector.js